<ngx-spinner [dir]="'rtl'" [bdColor] = "bgColor" size = "medium" [color] = "textColor" [type] = "spinnerType" [fullScreen] = "true" >
    <p [dir]="'rtl'" [style]="{'color': textColor}"  class="fontRegular fontlg">{{spinnerText}}</p>
</ngx-spinner>
